export function toggleTabs() {
	const tabButton = document.querySelectorAll( '.toggle-tab' );

	tabButton.forEach( ( tab ) => {
		tab.addEventListener( 'click', ( element ) => {
			const section = element.target.closest( 'section' );
			const tabIndex = element.target.dataset.tab;
			const tabContent = section.querySelector( '.tab-content[data-tab="' + tabIndex + '"]' );
			const otherTabs = section.querySelectorAll( '.contact-tab' );

			otherTabs.forEach( ( tab ) => {
				tab.classList.remove( 'active' );
			} );
			element.target.classList.add( 'active' );

			document.querySelectorAll( '.tab-content' ).forEach( ( tab ) => tab.classList.add( 'hidden' ) );

			tabContent.classList.remove( 'hidden' );
		} );
	} );
}

toggleTabs();
